import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        uid: null,
        email: null,
        displayName: null,
        photoURL: null,
        token: null,
        errorMessage: null,
        cargo: null,
        subscription: {
            is_trial: false,
            payment_vencido: false,
            trialEndsAt: null,
            subscriptionEndsAt: null
        }
    },
    reducers: {
        login: ( state, { payload } ) => {
            /* eslint-disable-line */
            state.uid = payload.uid;
            state.email = payload.email;
            state.displayName = payload.displayName;
            state.photoURL = payload.avatar;
            state.token = payload.token;
            state.errorMessage = null;
            state.cargo = payload.cargo;
            if (payload.subscription) {
                state.subscription.is_trial = payload.subscription.is_trial;
                state.subscription.payment_vencido = payload.subscription.payment_vencido;
                state.subscription.trialEndsAt = payload.subscription.trialEndsAt;
                state.subscription.subscriptionEndsAt = payload.subscription.subscriptionEndsAt;
            } else {
                state.subscription.is_trial = false;
                state.subscription.payment_vencido = false;
                state.subscription.trialEndsAt = null;
                state.subscription.subscriptionEndsAt = null;
            }
        },
        updatePhotoURL: ( state, { payload } ) => {
            state.photoURL = payload;
        },
        logout: ( state ) => {
            /* eslint-disable-line */
            state.uid = null;
            state.email = null;
            state.displayName = null;
            state.photoURL = null;
            state.token = null;
            state.errorMessage = null;
            state.cargo = null;
            state.subscription = {
                is_trial: false,
                payment_vencido: false,
                trialEndsAt: null,
                subscriptionEndsAt: null
            };
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { login, logout, updatePhotoURL } = authSlice.actions;